module.exports = __webpack_public_path__ + "static/img/ys-avatar.11efb81d.png";